const helpPage = {
  "help.faq.title": "FAQ",
  "help.faq.description": "You can find answers to all frequently asked questions here",
  "help.contact.title": "Contact",
  "help.contact.description": "Submit a request to our support team",
};

export const help = {
  ...helpPage,
};